var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var Org_1;
import { JSON, JsonSchema } from '@symon-ai/wisepipe-serialize';
import { Utils } from '@symon-ai/wisepipe-common';
export var OrgPlan;
(function (OrgPlan) {
    OrgPlan["Social"] = "Social";
    OrgPlan["Enterprise"] = "Enterprise";
    OrgPlan["Integration"] = "Integration";
    OrgPlan["Temp"] = "Temp";
    OrgPlan["Starter"] = "Starter";
    OrgPlan["Professional"] = "Professional";
})(OrgPlan || (OrgPlan = {}));
const schema = {
    $id: 'urn:wisepipe-user:Org',
    type: 'object',
    properties: {
        ID: { type: 'string', format: 'uuid' },
        orgPlan: { type: 'string', enum: Object.values(OrgPlan) }
    },
    required: ['ID', 'orgPlan']
};
let Org = Org_1 = class Org {
    // Returns the ID as a Buffer
    get bufferID() {
        return Utils.uuidStringToBuffer(this.ID);
    }
    constructor(id, orgPlan) {
        this.ID = id;
        this.orgPlan = orgPlan;
        JSON.validate(this, Org_1);
    }
    static bufferID(orgID) {
        return Utils.uuidStringToBuffer(orgID);
    }
    static orgID(buffer) {
        return Utils.uuidUintArrayToString(buffer);
    }
    static get OrgPlanHeader() {
        return 'wisepipe-org-plan';
    }
    static get OrgIDHeader() {
        return 'wisepipe-org-id';
    }
    static getInitialOrgName(fullName) {
        return `${fullName}'s organization`;
    }
};
Org = Org_1 = __decorate([
    JsonSchema(schema)
], Org);
export { Org };
//# sourceMappingURL=org.js.map